module.exports = __webpack_public_path__ + "static/media/bank.cadf8cbb.svg";